import React, { useState } from 'react';
import { SearchIcon, MapPinIcon } from 'lucide-react';
import { ulmClasses } from '../../data/classes';
export function BaseFinder() {
  const [query, setQuery] = useState('');
  const [classId, setClassId] = useState('all');
  const [submitted, setSubmitted] = useState(false);
  const label = classId === 'all' ? 'toutes classes' : ulmClasses.find(item => item.id === classId)?.name ?? '';
  return <section id="bases" className="bg-navy py-20 lg:py-24" data-id="element-15" data-mp="2dcxxb2wh2qvr">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-16" data-mp="2iah9lx9m0tl2">
        <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-end lg:gap-16" data-id="element-17" data-mp="2iazhjr5mww8t">
          <div data-id="element-18" data-mp="2n90v5wkak3cw">
            <h2 className="ffp-display text-3xl font-extrabold text-white sm:text-4xl" data-id="element-19" data-mp="2n8ituliruyy4">
              Trouver une base ULM près de chez vous
            </h2>
            <p className="mt-4 max-w-lg text-[16px] leading-relaxed text-white/75" data-id="element-20" data-mp="2ke9xz8aoy3t">
              Écoles, clubs et terrains privés déclarés : l’annuaire fédéral couvre les 1 200 bases du
              territoire, avec les classes pratiquées sur chacune.
            </p>
          </div>

          <form onSubmit={event => {
          event.preventDefault();
          setSubmitted(true);
        }} className="rounded-xl bg-white p-5 lg:p-6" data-id="element-21" data-mp="6kdhux2khwr5">
            <div className="grid gap-3 sm:grid-cols-[1.3fr_1fr]" data-id="element-22" data-mp="3tq4hvejvv9r2">
              <label className="block" data-id="element-23" data-mp="3trxl0jvafbub">
                <span className="mb-1.5 block text-[13px] font-semibold text-ink" data-id="element-24" data-mp="3oqrw6x4r08q2">Commune ou département</span>
                <div className="flex items-center gap-2 rounded-md border border-line px-3 py-2.5" data-id="element-25" data-mp="3jz00672tpasj">
                  <MapPinIcon className="h-4 w-4 shrink-0 text-ink/40" aria-hidden="true" data-id="element-26" data-mp="3f1i0766sa5wo" />
                  <input value={query} onChange={event => {
                  setQuery(event.target.value);
                  setSubmitted(false);
                }} placeholder="Ex. Loir-et-Cher, 41" className="w-full bg-transparent text-[15px] text-ink outline-none placeholder:text-ink/35" data-id="element-27" data-mp="3b04ssro1lunn" />
                </div>
              </label>
              <label className="block" data-id="element-28" data-mp="2wa1u1qgfboe1">
                <span className="mb-1.5 block text-[13px] font-semibold text-ink" data-id="element-29" data-mp="2hfxb66bmc2is">Classe</span>
                <select value={classId} onChange={event => {
                setClassId(event.target.value);
                setSubmitted(false);
              }} className="ffp-focus w-full rounded-md border border-line bg-white px-3 py-[11px] text-[15px] text-ink outline-none" data-id="element-30" data-mp="2mdf9l2s0ezcj">
                  <option value="all" data-id="element-31" data-mp="30c5g190pybdk">Toutes les classes</option>
                  {ulmClasses.map(item => <option key={item.id} value={item.id} data-id="element-32" data-mp="3t2xao224yrys">
                      {item.number} — {item.name}
                    </option>)}
                </select>
              </label>
            </div>
            <button type="submit" className="ffp-focus mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-flag px-5 py-3 text-[14px] font-semibold text-white transition-colors duration-150 ease-soft hover:bg-[#b81c22] sm:w-auto" data-id="element-33" data-mp="1mdmxti72ep6q">
              <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="1r4lhmrr9i5eq" />
              Rechercher une base
            </button>
            <p aria-live="polite" className="mt-3 text-[13px] text-ink/55" data-id="element-35" data-mp="13glt7yhfar3b">
              {submitted ? `Recherche lancée : ${query.trim() || 'toute la France'} — ${label}.` : 'Annuaire mis à jour par les clubs et les responsables de base.'}
            </p>
          </form>
        </div>
      </div>
    </section>;
}